// V2.1 Block Configuration (2026.1.1)
// Based on 2026.1.0 with the 2026.1.1 logout block added.

import { blocksV2 } from '../v2/blocksV2';
import SnapActionLogOut from '../v2/blocks/AppActions/LogOut';

export const blocksV2_1 = {
    ...blocksV2,
    "App Actions": {
        LogOut: {
            component: SnapActionLogOut,
            searchTags: ["log", "out", "logout", "actions", "user", "sign"]
        },
        ...blocksV2["App Actions"]
    }
};
